import { Box, Button, Container, Typography } from '@mui/material';

import { history } from '../../store/store';

export const NotFoundPage = () => {
  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <Container>
      <Box
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h1" component="h1" gutterBottom>
          404
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        <Typography color="text.secondary" paragraph>
          The page you're looking for doesn't exist.
        </Typography>
        <Button variant="contained" onClick={handleGoHome}>
          Go to Home
        </Button>
      </Box>
    </Container>
  );
};
